<template>
  <fieldset :class="[outerClass, 'legend-small-text']">
    <legend :class="['bv-no-focus-ring col-form-label pt-0', visible, legendClass]">
      {{ fieldLabel }}
    </legend>
    <label
      :for="propertyName"
      :class="labelClass"
    />
    <datepicker
      v-model="fieldValue"
      :class="[inputClass, invalidClass, 'adivare-datepicker !bg-white']"
      :id="propertyName"
      :name="propertyName"
      :placeholder="fieldLabel"
      :autocomplete="autocomplete"
      :ref="propertyName"
      :locale="datepickerLocale"
      inputFormat="dd-MM-yyyy"
    />
    <slot />
    <adivare-alert
      v-if="showError"
      class="mt-1"
      :messages="errorMessage"
      size="xs"
      show-icon
    />
  </fieldset>
</template>

<script>
import formMixin from "../../../mixins/form-mixin";
import Datepicker from 'vue3-datepicker';
import { nl, enUS } from 'date-fns/locale';
import AdivareAlert from '../../../../components/alert';
import { dateFormatter } from "../../../../translations";
import { empty } from "../../../../../js/util/util-functions";

export default {
  name: "adivare-date-form-element",
  mixins: [
    formMixin,
  ],
  components: {
    Datepicker,
    AdivareAlert,
  },
  data() {
    return {
      dateInstance: null,
    }
  },
  computed: {
    datepickerLocale() {
      return this.$i18n.locale === 'nl-NL' ? nl : enUS;
    },
    fieldValue: {
      get() {
        return this.dateInstance;
      },
      set(value) {
        this.dateInstance = value;
        if (!this.validateField(value)) {
          return;
        }
        this.$store.dispatch('updateFormField', {
          name: this.propertyName,
          value: dateFormatter.format(value, {
            dateStyle: 'short',
          }),
        });
      },
    },
    visible() {
      return false === empty(this.fieldValue) ? 'visible' : 'invisible';
    },
    fieldIsValid() {
      // Either the field is validated, or it is optional and empty.
      return this.$store.getters.getFormFieldValidityState(this.propertyName) ||
        (true === this.optional && true === empty(this.fieldValue));
    },
    showError() {
      return true === this.$store.getters.showErrors &&
        false === this.fieldIsValid;
    },
    invalidClass() {
      return true === this.showError ? 'is-invalid' : '';
    },
    errorMessage() {
      return this.$t('messages_nl.global.required');
    },
  },
  methods: {
    validateField(dateValue) {
      const validDate = dateValue instanceof Date;
      this.$store.commit('updateFormFieldValidity', {
        name: this.propertyName,
        valid: validDate || this.optional,
      });
      return validDate;
    }
  },
}
</script>

<style>
  .adivare-datepicker[readonly] {
    background-color: transparent;
  }
</style>
